import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BoxV2 } from '@labrav/react-components'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import React from 'react'
import { BuyerLifeCycleNotificationFaqs } from './NotificationBoxWrapperHelpFaqs/BuyerLifeCycleNotificationFaqs'
import { ListingNotificationFaqs } from './NotificationBoxWrapperHelpFaqs/ListingNotificationFaqs'
import { PrivateOfferNotificationFaqs } from './NotificationBoxWrapperHelpFaqs/PrivateOfferNotificationFaqs'
import { MeteringNotificationFaqs } from './NotificationBoxWrapperHelpFaqs/MeteringNotificationFaqs'
import { ResaleAuthorizationNotificationFaqs } from './NotificationBoxWrapperHelpFaqs/ResaleAuthorizationNotificationFaqs'

export interface NotificationBoxWrapperProps {
  heading: string
  helperSectionName: string
  icon: IconProp
  children: React.ReactNode
}

export const NotificationBoxWrapper = ({
  heading,
  helperSectionName,
  icon,
  children,
}: NotificationBoxWrapperProps) => {
  const [indexModal, setIndexModal] = React.useState<number>(0)
  const props = {
    indexModal,
    setIndexModal,
  }

  const notificationHelpFaqDrawer = () => {
    switch (helperSectionName) {
      case 'flyOutBuyerLifecycleNotifications':
        return <BuyerLifeCycleNotificationFaqs {...props} />
      case 'flyOutListingNotifications':
        return <ListingNotificationFaqs {...props} />
      case 'flyOutPrivateOfferNotifications':
        return <PrivateOfferNotificationFaqs {...props} />
      case 'flyOutMeteringNotifications':
        return <MeteringNotificationFaqs {...props} />
      case 'flyOutResaleNotifications':
        return <ResaleAuthorizationNotificationFaqs {...props} />
      default:
        return <></>
    }
  }

  return (
    <BoxV2
      heading={heading}
      headingIcon={
        <FontAwesomeIcon
          icon={icon}
          style={{ width: '18px', height: '14px' }}
        />
      }
      secondaryActions={notificationHelpFaqDrawer()}
    >
      {children}
    </BoxV2>
  )
}
